/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PromptListRequest {
    getFixupPrototypeFunction() { return PromptListRequest.fixupPrototype; }

    static newInstance(model: Partial<PromptListRequest>): PromptListRequest {
        let obj = Object.assign(new PromptListRequest(), model);
        PromptListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PromptListRequest>): PromptListRequest {
        if (!model) return null;
        return PromptListRequest.newInstance(<PromptListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PromptListRequest) {
        if (!obj) return;

        models.PromptListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PromptListRequest): boolean {
        Object.setPrototypeOf(obj, PromptListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.PromptFilters.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.PromptSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.PromptSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.PromptFilters;

}
